import { render, staticRenderFns } from "./BaseTaskIcon.vue?vue&type=template&id=689b914a&scoped=true"
import script from "./BaseTaskIcon.vue?vue&type=script&lang=js"
export * from "./BaseTaskIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689b914a",
  null
  
)

export default component.exports